import React, { useState, useEffect } from "react";
import { REACT_APP_API_URL } from "../../../../env";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import SimpleRichTextEditor from "../Components/Simplerichtexteditor";

const PropertiesForm = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEditMode = Boolean(id);

    const [unitName, setUnitName] = useState('');
    const [unitTypes, setUnitTypes] = useState([]);
    const [propertyType, setPropertyType] = useState('');
    const [propertyName, setPropertyName] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [landlineNumber, setLandlineNumber] = useState('');
    const [fax, setFax] = useState('');
    const [emailId, setEmailId] = useState('');
    const [address, setAddress] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [pincode, setPincode] = useState('');
    const [snippet, setSnippet] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [propertyAbbreviation, setPropertyAbbreviation] = useState('');
    const [showInWebsite, setShowInWebsite] = useState('Yes');
    const [bookingAvailable, setBookingAvailable] = useState('Yes');
    const [propertyInformation, setPropertyInformation] = useState('');
    const [loading, setLoading] = useState(isEditMode);

    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');

    useEffect(() => {
        axios.get(`${REACT_APP_API_URL}api/dashboard/admin/unit-types`)
            .then(res => { if (res.data.success) setUnitTypes(res.data.data); })
            .catch(err => console.error("Failed to fetch unit types:", err));

        axios.get(`${REACT_APP_API_URL}api/dashboard/admin/location/states`)
            .then(res => setStates(res.data))
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        if (!isEditMode) return;

        axios.get(`${REACT_APP_API_URL}api/dashboard/admin/property/edit/${id}`)
            .then(res => {
                const p = res.data?.data;
                if (!p) return;
                setUnitName(p.UnitName || '');
                setPropertyType(p.PropertyTypeID || '');
                setPropertyName(p.PropertyName || p.vchPropertyName || '');
                setCustomerName(p.ContactPerson || '');
                setMobileNumber(p.MobileNo || '');
                setLandlineNumber(p.LandLineNo || '');
                setFax(p.FAXNo || '');
                setEmailId(p.EmailID || '');
                setAddress(p.Address || '');
                setSelectedState(p.StateID ? String(p.StateID) : '');
                setSelectedCity(p.CityID ? String(p.CityID) : '');
                setSelectedDistrict(p.DistrictID ? String(p.DistrictID) : '');
                setSelectedLocation(p.LocationID ? String(p.LocationID) : '');
                setPincode(p.PIN || '');
                setSnippet(p.Snippet || '');
                setLatitude(p.Latitude || '');
                setLongitude(p.Longitude || '');
                setPropertyAbbreviation(p.Abbreviation || '');
                setShowInWebsite(p.ShowinWeb === 0 ? 'Yes' : 'No');
                setBookingAvailable(p.BookingAvailable === 1 ? 'Yes' : 'No');
                setPropertyInformation(p.PropertyDetails || '');
            })
            .catch(err => console.error("Failed to fetch property:", err))
            .finally(() => setLoading(false));
    }, [id, isEditMode]);

    useEffect(() => {
        if (selectedState) {
            axios.get(`${REACT_APP_API_URL}api/dashboard/admin/location/cities/${selectedState}`)
                .then(res => setCities(res.data.data || res.data))
                .catch(err => console.error(err));

            axios.get(`${REACT_APP_API_URL}api/dashboard/admin/location/districts`)
                .then(res => setDistricts(res.data.data))
                .catch(err => console.error(err));
        } else {
            setCities([]);
            setSelectedCity('');
        }
    }, [selectedState]);

    useEffect(() => {
        if (selectedDistrict) {
            axios.get(`${REACT_APP_API_URL}api/dashboard/admin/location/locations/${selectedDistrict}`)
                .then(res => setLocations(res.data))
                .catch(err => console.error(err));
        }
    }, [selectedDistrict]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const stateObj = states.find(s => String(s.StateID) === String(selectedState));
        const cityObj = cities.find(c => String(c.CityID) === String(selectedCity));

        const payload = {
            vchUnitName: unitName,
            intPropertyTypeID: parseInt(propertyType),
            vchPropertyName: propertyName,
            vchMobileNo: mobileNumber,
            vchLandLineNo: landlineNumber,
            vchFAXNo: fax,
            vchEmailID: emailId,
            vchAddress: address,
            vchContactPerson: customerName,
            intStateID: parseInt(selectedState),
            vchState: stateObj ? stateObj.State : '',
            intCityID: parseInt(selectedCity) || 0,
            vchCity: cityObj ? cityObj.City : '',
            intDistrictID: parseInt(selectedDistrict),
            intLocationID: parseInt(selectedLocation),
            vchPIN: pincode,
            vchSnippet: snippet,
            vchLatitude: latitude?.trim(),
            vchLongitude: longitude?.trim(),
            vchPropertyAbbreviation: propertyAbbreviation,
            intShowinWeb: showInWebsite === "Yes" ? 0 : 1,
            intBookingAvailable: bookingAvailable === "Yes" ? 1 : 0,
            vchPropertyInfoDetails: propertyInformation,
            intCreatedBy: 1
        };

        try {
            let response;
            if (isEditMode) {
                payload.intPropertyId = id;
                response = await axios.put(
                    `${REACT_APP_API_URL}api/dashboard/admin/property/update/${id}`,
                    payload
                );
            } else {
                response = await axios.post(
                    `${REACT_APP_API_URL}api/dashboard/admin/property/add-property`,
                    payload
                );
            }

            if (response.data.success) {
                alert(isEditMode ? "Property updated successfully!" : "Property saved successfully!");
                if (isEditMode) navigate("/properties-list");
            } else {
                alert(isEditMode ? "Failed to update property." : "Failed to save property.");
            }
        } catch (err) {
            console.error("Submit error:", err);
            alert(isEditMode ? "Error while updating property." : "Error while saving property.");
        }
    };

    if (loading) {
        return <div className="container mt-4">Loading property details...</div>;
    }

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-end mb-2">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => navigate("/properties-list")}
                >
                    View All Properties
                </button>
            </div>

            <div className="card">
                <div className="card-header bg-primary text-white">
                    <h3 className="mb-0">{isEditMode ? "Edit Property" : "Add Property"}</h3>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Unit Name</label>
                                <input type="text" className="form-control" value={unitName} onChange={(e) => setUnitName(e.target.value)} required />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Property Type</label>
                                <select className="form-select" value={propertyType} onChange={(e) => setPropertyType(e.target.value)} required>
                                    <option value="">Select Property Type</option>
                                    {unitTypes.map(type => (
                                        <option key={type.PropertyID} value={type.PropertyTypeID}>
                                            {type.PropertyTypeName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Contact Person</label>
                                <input type="text" className="form-control" value={customerName} onChange={(e) => setCustomerName(e.target.value)} required />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Property Name</label>
                                <input type="text" className="form-control" value={propertyName} onChange={(e) => setPropertyName(e.target.value)} required />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Mobile Number</label>
                                <input type="text" className="form-control" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} required />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Landline Number</label>
                                <input type="text" className="form-control" value={landlineNumber} onChange={(e) => setLandlineNumber(e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Fax</label>
                                <input type="text" className="form-control" value={fax} onChange={(e) => setFax(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Email ID</label>
                                <input type="email" className="form-control" value={emailId} onChange={(e) => setEmailId(e.target.value)} required />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Address</label>
                                <input type="text" className="form-control" value={address} onChange={(e) => setAddress(e.target.value)} required />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">State</label>
                                <select className="form-select" value={selectedState} onChange={(e) => setSelectedState(e.target.value)} required>
                                    <option value="">Select State</option>
                                    {states.map(s => (
                                        <option key={s.StateID} value={s.StateID}>{s.State}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">City</label>
                                <select className="form-select" value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)} required>
                                    <option value="">Select City</option>
                                    {cities.map(c => (
                                        <option key={c.CityID} value={c.CityID}>{c.City}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">District</label>
                                <select className="form-select" value={selectedDistrict} onChange={(e) => setSelectedDistrict(e.target.value)} required>
                                    <option value="">Select District</option>
                                    {districts.map(d => (
                                        <option key={d.DistrictID} value={d.DistrictID}>{d.District}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Location</label>
                                <select className="form-select" value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)} required>
                                    <option value="">Select Location</option>
                                    {locations.map(l => (
                                        <option key={l.LocationID} value={l.LocationID}>{l.LocationName}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Pin Code</label>
                                <input type="text" className="form-control" value={pincode} onChange={(e) => setPincode(e.target.value)} required />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Snippet</label>
                                <input type="text" className="form-control" value={snippet} onChange={(e) => setSnippet(e.target.value)} required />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Latitude</label>
                                <input type="text" className="form-control" value={latitude} onChange={(e) => setLatitude(e.target.value)} required />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Longitude</label>
                                <input type="text" className="form-control" value={longitude} onChange={(e) => setLongitude(e.target.value)} required />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Property Abbreviation</label>
                                <input type="text" className="form-control" value={propertyAbbreviation} onChange={(e) => setPropertyAbbreviation(e.target.value)} required />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label d-block">Show in Website</label>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="showInWebsite" id="showYes" value="Yes"
                                        checked={showInWebsite === 'Yes'} onChange={(e) => setShowInWebsite(e.target.value)} />
                                    <label className="form-check-label" htmlFor="showYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="showInWebsite" id="showNo" value="No"
                                        checked={showInWebsite === 'No'} onChange={(e) => setShowInWebsite(e.target.value)} />
                                    <label className="form-check-label" htmlFor="showNo">No</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label d-block">Booking Available</label>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="bookingAvailable" id="bookingYes" value="Yes"
                                        checked={bookingAvailable === 'Yes'} onChange={(e) => setBookingAvailable(e.target.value)} />
                                    <label className="form-check-label" htmlFor="bookingYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="bookingAvailable" id="bookingNo" value="No"
                                        checked={bookingAvailable === 'No'} onChange={(e) => setBookingAvailable(e.target.value)} />
                                    <label className="form-check-label" htmlFor="bookingNo">No</label>
                                </div>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-8">
                                <label className="form-label fw-bold text-primary">
                                    Property Information Details
                                </label>
                               
                                <SimpleRichTextEditor
                                    value={propertyInformation}
                                    onChange={setPropertyInformation}
                                    placeholder="Write property details..."
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-end">
                            {isEditMode ? (
                                <button type="button" className="btn btn-secondary me-2" onClick={() => navigate("/properties-list")}>Cancel</button>
                            ) : (
                                <button type="reset" className="btn btn-secondary me-2">Reset</button>
                            )}
                            <button type="submit" className="btn btn-primary">
                                {isEditMode ? "Update Property" : "Add Property"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PropertiesForm;